var _polygon, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73.73 25.88 25.48 25.88 16.97 25.88 23.62 97.77 25.48 97.77 73.73 97.77 75.6 97.77 82.24 25.88 73.73 25.88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.68,4.18l-24.71,4.38-.62-3.48h0c-.21-1.18-.87-2.21-1.85-2.9-.98-.69-2.18-.95-3.36-.74l-17.53,3.11c-.05,0-.1.02-.15.04-2.43.51-4.04,2.87-3.6,5.33l.59,3.35-24.38,4.32,1.47,8.3,75.61-13.4-1.47-8.3ZM38.95,6.52s.09-.02.13-.03l17.4-3.08c.65-.12,1.32.03,1.87.41.55.38.92.96,1.03,1.61l.6,3.39-22.58,4-.58-3.26c-.25-1.42.7-2.79,2.12-3.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.21,88.38c-1.02,0-1.9-.77-1.99-1.8l-4.39-48.47c-.1-1.09.71-2.04,1.81-2.14,1.11-.09,2.07.7,2.17,1.79l4.39,48.47c.1,1.09-.71,2.04-1.81,2.14h-.18,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.39,88.38c-1.1,0-2-.88-2-1.97v-48.47c0-1.09.9-1.97,2-1.97s2,.88,2,1.97v48.47c0,1.09-.9,1.97-2,1.97Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.56,88.38h-.16c-1.1-.08-1.92-1.03-1.84-2.12l3.82-48.4c.09-1.09,1.05-1.89,2.15-1.81,1.1.08,1.92,1.03,1.84,2.12l-3.82,48.4c-.08,1.03-.96,1.82-1.99,1.82h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.e802fb848658d95b6ca8e2f15d602351.svg";
export { ForwardRef as ReactComponent };